export default "__VITE_ASSET__CDDiubzA__"